function SmxRenderLineMarks(){
    const   underline_els = document.querySelectorAll('.smx-animated-underline'),
            circle_els = document.querySelectorAll('.smx-animated-circle-doodle'),
            stroke_color = 'var(--smx-primary-color)',
            min_stroke_width = 3,
            max_stroke_width = 10,
            underline_path_height_percent = 10,
            timing_per_100px = 0.3,
            timing_per_100px_underline = 0.1;

    underline_els.forEach( (item, index) => {

        var paths_data = [];

        /**
         * First of all check if the text has more than one row and divide it in words
         * For the multiline option is needed a sub span with smx-h-ref class
         */


        var h_ref = item.querySelector('.smx-h-ref');
        var text_lines = 1;

        /**
         * Check if the item is too long for the viewport and calculate the lines.
         * default 1 line 
         */

        var h_ref_height = item.offsetHeight;

        if(h_ref){
            h_ref_height = h_ref.offsetHeight;
            var item_height = item.offsetHeight;

            if(h_ref_height != item_height){
                text_lines = item_height / h_ref_height;
            }
        }

        if(text_lines > 1){

            item.classList.add('multiline');

            /**
             * If the item has more than one line split the phrase in spans with word class
             */

            var text_content = item.textContent;
            var content_arr = text_content.split(" ");

            item.dataset.textContent = text_content;
            item.dataset.referenceHeight = h_ref_height;

            item.innerHTML = '';

            
            content_arr.forEach((word) => {
                var element = document.createElement('span');
                // var sub_element = document.createElement('span');
                element.setAttribute('class', 'word');
                element.textContent = word + ' ';
                //sub_element.textContent = word + ' ';
                // element.appendChild(sub_element);
                item.appendChild(element);
                
            });


            

        }
        
        
        /**
         * When is defined if the text is multiline and eventualy split the phares in words is possible to have the absolute position and width of any single word and row.
         * So:
         * * if the phrase has only one line is simple to define the path position
         * * if the phrase has more than one line is calculated the position of any single word and It's assign to de row.
         */

        var words = item.querySelectorAll('.word');
        var rows = [];

        if(text_lines > 1){

            words.forEach((word) => {
                var word_rect = word.getBoundingClientRect();
                if(!rows[word_rect.top]){
                    rows[word_rect.top] = {};
                    rows[word_rect.top].width = 0;
                    rows[word_rect.top].top = word_rect.top;
                    rows[word_rect.top].height = word.offsetHeight;
                }
                rows[word_rect.top].width += word.offsetWidth;
                if( word.offsetHeight > rows[word_rect.top].height ){
                    rows[word_rect.top].height = word.offsetHeight;
                }

            });



        }else{

            rows[0] = {
                width: item.offsetWidth,
                top: 0,
                height: item.offsetHeight,
            }

        }


        Object.values(rows).forEach((row, row_index) => {

            if(!paths_data[row_index]){
                paths_data[row_index] = {};
            }

            var stroke_width = row.height / 100*13;
            var path_height = (( (row.height / 100 * underline_path_height_percent ) < (stroke_width * 3) ) ? stroke_width * 2.3 : row.height / 100 * underline_path_height_percent );
            var item_height = (path_height > row.height) ? path_height + stroke_width : row.height;
            var drawing_time = ((row.width / 100 * timing_per_100px_underline) >= timing_per_100px) ? row.width / 100 * timing_per_100px_underline : timing_per_100px;

            paths_data[row_index] = {
                item_width: row.width,
                item_height: item_height,
                path_width:  row.width,
                stroke_width: stroke_width,
                path_h: path_height,
                drawing_time: drawing_time,
                path_top: (h_ref_height * (row_index+1)) - stroke_width,
                path_bottom: ((h_ref_height * (row_index+1)) + path_height) - stroke_width ,
                path_left: stroke_width,
                path_right: row.width - stroke_width,
            };

        });

        var svg_w = item.offsetWidth,
            svg_h = item.offsetHeight + paths_data[0].path_h;

        var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

        svg.setAttribute('xmlns', "http://www.w3.org/2000/svg");
        svg.setAttribute('width', svg_w);
        svg.setAttribute('height', svg_h );
        svg.setAttribute('viewBox', "0 0 " + (svg_w ) + " " + (svg_h ));
        svg.setAttribute('preserveAspectRatio', "none");
        svg.setAttribute('id', "smx-animated-underline-" + index );

        var paths = [];

        paths_data.forEach((path_data, path_index) => {

            paths[path_index] = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            paths[path_index].setAttribute( 'id', 'smx-underline-path' + index + '_' + path_index );
            paths[path_index].setAttribute( 'class', 'smx-underline' );
            paths[path_index].setAttribute( 'd', 'M ' + path_data.path_left + ' ' + path_data.path_bottom + ' C ' + ( path_data.path_width  / 100*10) + ' ' + path_data.path_top + ', ' +  (path_data.path_width - (path_data.path_width/100*10)) + ' ' + path_data.path_top + ', ' + path_data.path_right + ' ' + path_data.path_bottom );
            paths[path_index].setAttribute( 'fill', 'none' );
            // paths[path_index].setAttribute( 'stroke',  stroke_color);
            paths[path_index].setAttribute( 'stroke-linecap', 'round' );
            paths[path_index].setAttribute( 'stroke-width', path_data.stroke_width );
            paths[path_index].setAttribute( 'pathLength', "1" );
            paths[path_index].setAttribute( 'style', "animation-duration: " + path_data.drawing_time +"s; stroke: " + stroke_color + ";" );

            svg.appendChild( paths[path_index] );

        });

        item.appendChild( svg );

    });



    circle_els.forEach((item, index) => {
        var item_w = item.offsetWidth;
        var item_h = item.offsetHeight;

        

        var stroke_width = item_h / 100*13;
        if(stroke_width < min_stroke_width){
            stroke_width = min_stroke_width;
        }

        if(stroke_width > max_stroke_width){
            stroke_width = max_stroke_width;
        }

        var min_path_h = stroke_width * 3;
      

        var path_w = (item_w/100*110) + (stroke_width*2);
        var path_h = (item_h/100*110) + (stroke_width*2);

        if(path_h < min_path_h){
            path_h = min_path_h;
        }

        var drawing_time = ((path_w*2 + path_h) /100) * timing_per_100px;
        
        var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');

        svg.setAttribute('xmlns', "http://www.w3.org/2000/svg");
        svg.setAttribute('width', path_w);
        svg.setAttribute('height', path_h);
        svg.setAttribute('viewBox', "0 0 " + (path_w ) + " " + (path_h ));
        svg.setAttribute('preserveAspectRatio', "none");
        svg.setAttribute('id', "smx-animated-circle-doodle-" + index );

        path.setAttribute( 'id', 'smx-underline-path' + index );
        path.setAttribute( 'class', 'smx-circle-doodle-path' );

        var path_track = "M " + ((path_w/2)- (stroke_width*3)) + ' ' +( stroke_width*2 );
        path_track += " C " + (path_w/100*30) + ' ' + stroke_width + ', ' + stroke_width + ' ' + stroke_width + ', ' + stroke_width + ' ' + (path_h/100*50);
        path_track += " S " + (path_w/100*30) + ' ' + (path_h - stroke_width) + ', ' + (path_w/2) + ' ' + (path_h - stroke_width);
        path_track += " S " + (path_w - stroke_width) + ' ' + (path_h - stroke_width) + ', ' + (path_w - stroke_width) + ' ' + (path_h/100*50);
        path_track += " S " + (path_w - (path_w/100*30)) + ' ' + (stroke_width) + ', ' + (path_w - ((path_w/2)- (stroke_width*3))) + ' ' + stroke_width;

        path.setAttribute( 'd', path_track );
        path.setAttribute( 'fill', 'none' );
        path.setAttribute( 'stroke',  stroke_color);
        path.setAttribute( 'stroke-linecap', 'round' );
        path.setAttribute( 'stroke-width', stroke_width );
        path.setAttribute( 'pathLength', "1" );
        path.setAttribute( 'style', "animation-duration: " + drawing_time +"s;" );

        svg.appendChild( path );
        item.appendChild( svg );


    });

    ObserveClassAndShow(['.smx-animated-circle-doodle', '.smx-animated-underline'])

}


function ObserveClassAndShow (selectors) {

    

    selectors.forEach((selector) => {
        var items = document.querySelectorAll(selector);

        items.forEach((item) => {

            let callback = (entry) => {
                var is_intersecting = entry[0].isIntersecting;
        
                if(is_intersecting){
                    item.classList.add('show');
                }
        
            }

            let options,
                observer,
                target;

            options = {
                rootMargin: "-0% 0% -30% 0%",
                threshold: [1.0],
            }

            observer = new IntersectionObserver(callback, options);
            target = item;
            observer.observe(target);

        });

    });

    

    
}

export default { SmxRenderLineMarks }
